var map = {
	"./images/AI.svg": 43649,
	"./images/HelpChat.svg": 61520,
	"./images/_logo.svg": 65279,
	"./images/account/check_list.svg": 90432,
	"./images/account/company.svg": 88492,
	"./images/account/notifications.svg": 27373,
	"./images/account/secure.svg": 52544,
	"./images/account/user.svg": 16990,
	"./images/account/wallet.svg": 75932,
	"./images/alert.svg": 54631,
	"./images/assessment/EnvironmentalImpacts.svg": 6441,
	"./images/assessment/ImpactsCulturalHeritage.svg": 14552,
	"./images/assessment/SocialEconomicImpacts.svg": 62635,
	"./images/assessment/airplane.svg": 65462,
	"./images/assessment/check-list.svg": 76993,
	"./images/assessment/cup.svg": 41992,
	"./images/assessment/cycle.svg": 96510,
	"./images/assessment/drops.svg": 9338,
	"./images/assessment/emissions-icon.svg": 72234,
	"./images/assessment/finger-EnvironmentalImpacts.svg": 64245,
	"./images/assessment/finger-ImpactsCulturalHeritage.svg": 14228,
	"./images/assessment/finger-SocialEconomicImpacts.svg": 43751,
	"./images/assessment/finger-SustainableOrgMng.svg": 95893,
	"./images/assessment/governance-icon.svg": 63730,
	"./images/assessment/gstc/EnvironmentalImpacts.jpg": 49681,
	"./images/assessment/gstc/EnvironmentalImpacts.svg": 23053,
	"./images/assessment/gstc/ImpactsCulturalHeritage.jpg": 23774,
	"./images/assessment/gstc/ImpactsCulturalHeritage.svg": 9132,
	"./images/assessment/gstc/SocialEconomicImpacts.jpg": 59169,
	"./images/assessment/gstc/SocialEconomicImpacts.svg": 9759,
	"./images/assessment/gstc/SustainableOrgMng.jpg": 83783,
	"./images/assessment/gstc/SustainableOrgMng.svg": 39917,
	"./images/assessment/gstc/banner-1.png": 75160,
	"./images/assessment/gstc/banner-2.png": 49651,
	"./images/assessment/gstc/banner-3.png": 94442,
	"./images/assessment/gstc/banner-4.png": 79109,
	"./images/assessment/gstc/banner-5.png": 66044,
	"./images/assessment/gstc/banner-6.png": 50327,
	"./images/assessment/gstc/banner-7.png": 7310,
	"./images/assessment/gstc/culture.svg": 34846,
	"./images/assessment/icon-1.svg": 49537,
	"./images/assessment/idea.svg": 44757,
	"./images/assessment/menu/EnvironmentalImpacts.svg": 81745,
	"./images/assessment/menu/ImpactsCulturalHeritage.svg": 41728,
	"./images/assessment/menu/SocialEconomicImpacts.svg": 19635,
	"./images/assessment/menu/SustainableOrgMng.svg": 16345,
	"./images/assessment/nofound.svg": 487,
	"./images/assessment/power-icon.svg": 61891,
	"./images/assessment/publication.svg": 23010,
	"./images/assessment/social-icon.svg": 3361,
	"./images/assessment/thumb-up-EnvironmentalImpacts.svg": 27826,
	"./images/assessment/thumb-up-ImpactsCulturalHeritage.svg": 84713,
	"./images/assessment/thumb-up-SocialEconomicImpacts.svg": 994,
	"./images/assessment/thumb-up-SustainableOrgMng.svg": 92420,
	"./images/assessment/time.svg": 49239,
	"./images/assessment/transportation-icon.svg": 86712,
	"./images/assessment/waste-icon.svg": 45164,
	"./images/assessment/water-icon.svg": 51357,
	"./images/badges/badge1.svg": 25860,
	"./images/badges/badge2.svg": 68983,
	"./images/badges/badge3.svg": 81446,
	"./images/badges/badge4.svg": 84041,
	"./images/badges/badge5.svg": 49176,
	"./images/box-plus.svg": 80091,
	"./images/calculator.svg": 78451,
	"./images/certifications/BCorp.svg": 92805,
	"./images/certifications/B_Corp.svg": 50508,
	"./images/certifications/Blue_Flag.svg": 67078,
	"./images/certifications/EarthCheck.svg": 9349,
	"./images/certifications/GSTC.svg": 69848,
	"./images/certifications/GreenKey.svg": 59955,
	"./images/certifications/Green_Globe.svg": 88468,
	"./images/certifications/ISO.svg": 30680,
	"./images/certifications/ISO_14001.svg": 20361,
	"./images/certifications/ISO_50001.svg": 69793,
	"./images/certifications/Travelife.svg": 1,
	"./images/certifications/image 3.svg": 46955,
	"./images/certifications/sustainableGME.png": 547,
	"./images/check-icon.svg": 47645,
	"./images/collection.svg": 65815,
	"./images/demo/features/activities.png": 18544,
	"./images/demo/features/assessment-report.png": 9322,
	"./images/demo/features/assessments-hub.png": 27264,
	"./images/demo/features/audit.png": 42054,
	"./images/demo/features/cases.png": 24332,
	"./images/demo/features/certifications.png": 89326,
	"./images/demo/features/communication.png": 92327,
	"./images/demo/features/company-profile.png": 48786,
	"./images/demo/features/goal-sheet.png": 57068,
	"./images/demo/features/gri.png": 42967,
	"./images/demo/features/gstc-assessment.png": 41755,
	"./images/demo/features/marketing-kit.png": 76408,
	"./images/demo/features/master-dashboard.png": 27638,
	"./images/demo/features/monitor-report.png": 22542,
	"./images/demo/features/monitor.png": 26817,
	"./images/demo/features/plan-hub.png": 49536,
	"./images/demo/features/protocols.png": 82052,
	"./images/demo/features/public-profile.png": 70600,
	"./images/demo/features/quick-estimate.png": 72219,
	"./images/demo/features/report-center.png": 73759,
	"./images/demo/features/repository.png": 62871,
	"./images/demo/features/roadmap.png": 34571,
	"./images/demo/features/shipping-dashboard.png": 77690,
	"./images/demo/features/supplier-eval.png": 43340,
	"./images/demo/features/supplier-portfolio.png": 4052,
	"./images/demo/features/task-detail.png": 90640,
	"./images/demo/features/tour-design.png": 58742,
	"./images/demo/features/tour-sheets.png": 45000,
	"./images/demo/features/training.png": 89065,
	"./images/demo/features/vsme.png": 91604,
	"./images/demo/hero-sustainability.jpg": 73685,
	"./images/demo/network/01-network-kpis.png": 5572,
	"./images/demo/network/01-portfolio.png": 51244,
	"./images/demo/network/02-operators.png": 37828,
	"./images/demo/network/02-progress.png": 18374,
	"./images/demo/network/03-drill-in.png": 41633,
	"./images/demo/network/03-geography.png": 83092,
	"./images/demo/network/04-carbon.png": 10182,
	"./images/demo/network/04-initiatives.png": 2984,
	"./images/demo/network/05-impact.png": 45216,
	"./images/demo/network/06-portfolio.png": 43483,
	"./images/demo/network/07-certifications.png": 7189,
	"./images/demo/network/07-drill-in.png": 22186,
	"./images/demo/network/08-invite.png": 43066,
	"./images/demo/operators/01-welcome.png": 65887,
	"./images/demo/operators/02-assessment.png": 68688,
	"./images/demo/operators/03-ai-responses.png": 20960,
	"./images/demo/operators/04-score.png": 10144,
	"./images/demo/operators/05-action-plan.png": 18585,
	"./images/demo/operators/06-task.png": 65873,
	"./images/demo/operators/07-ai-verify.png": 90837,
	"./images/demo/operators/08-quick-estimate.png": 4512,
	"./images/demo/operators/09-monitor.png": 89881,
	"./images/demo/operators/10-reports.png": 79048,
	"./images/demo/operators/11-certification.png": 99682,
	"./images/demo/operators/12-progress.png": 72054,
	"./images/demo/operators/13-training.png": 62522,
	"./images/demo/operators/14-audit.png": 83432,
	"./images/download-icon.svg": 88723,
	"./images/electricity.svg": 65886,
	"./images/emissions.svg": 55617,
	"./images/face.svg": 47184,
	"./images/finger.svg": 86336,
	"./images/globe.svg": 26314,
	"./images/gme-circle.svg": 63597,
	"./images/gme-logo.svg": 78632,
	"./images/gmeblanco.png": 12199,
	"./images/graph.svg": 89929,
	"./images/gri/environmental.svg": 28384,
	"./images/gri/general.svg": 50748,
	"./images/gri/governance.svg": 29768,
	"./images/gri/gri-content.jpg": 75686,
	"./images/gri/gri-software.jpg": 78774,
	"./images/gri/icon-page-1.svg": 52459,
	"./images/gri/settings.svg": 61875,
	"./images/gri/social.svg": 5845,
	"./images/gri/topics.svg": 23800,
	"./images/gri/welcome.svg": 67984,
	"./images/gstc-certification.png": 85839,
	"./images/hands.svg": 27919,
	"./images/icon-fossil.svg": 85105,
	"./images/icon-power.svg": 8540,
	"./images/icons/AI-alto.svg": 31745,
	"./images/icons/AI.svg": 59708,
	"./images/icons/AIBlack.svg": 57005,
	"./images/icons/astronomy.svg": 40340,
	"./images/icons/book-green.svg": 64455,
	"./images/icons/book-light-green.svg": 85880,
	"./images/icons/book.svg": 58049,
	"./images/icons/check-mark-green.svg": 83358,
	"./images/icons/check-mark.svg": 36796,
	"./images/icons/collection.svg": 5666,
	"./images/icons/collectionIconBlack.svg": 1750,
	"./images/icons/company.svg": 79567,
	"./images/icons/config.svg": 85976,
	"./images/icons/connect-light.svg": 90183,
	"./images/icons/connect.svg": 66620,
	"./images/icons/cup-dark.svg": 82503,
	"./images/icons/cup.svg": 85150,
	"./images/icons/cycle.svg": 50112,
	"./images/icons/document.svg": 85073,
	"./images/icons/edit.svg": 23374,
	"./images/icons/emissions.svg": 15134,
	"./images/icons/flag-alto.svg": 41053,
	"./images/icons/flag.svg": 98944,
	"./images/icons/glasses.png": 29228,
	"./images/icons/glasses.svg": 11446,
	"./images/icons/globe.svg": 61761,
	"./images/icons/governance.svg": 97562,
	"./images/icons/graph-dark-green.svg": 70789,
	"./images/icons/graph-light-green.svg": 85967,
	"./images/icons/help-square.svg": 74065,
	"./images/icons/icon-arrow-right.svg": 90332,
	"./images/icons/icon-astronomy.svg": 40808,
	"./images/icons/icon-beach-cleanups.svg": 45299,
	"./images/icons/icon-book-blue.svg": 2674,
	"./images/icons/icon-book.svg": 94149,
	"./images/icons/icon-botanics.svg": 59627,
	"./images/icons/icon-carbon.svg": 80433,
	"./images/icons/icon-chat.svg": 30828,
	"./images/icons/icon-check-list.svg": 36611,
	"./images/icons/icon-check.svg": 59758,
	"./images/icons/icon-checkmark-blue.svg": 12062,
	"./images/icons/icon-coastal.svg": 50999,
	"./images/icons/icon-community-blue.svg": 75986,
	"./images/icons/icon-company-blue.svg": 48736,
	"./images/icons/icon-connect.svg": 34960,
	"./images/icons/icon-cultural.svg": 99720,
	"./images/icons/icon-cycle.svg": 68108,
	"./images/icons/icon-document.svg": 3645,
	"./images/icons/icon-dowloand-file.svg": 44977,
	"./images/icons/icon-drops-blue.svg": 43973,
	"./images/icons/icon-earth.svg": 4082,
	"./images/icons/icon-eductations.svg": 58101,
	"./images/icons/icon-electricity.svg": 67329,
	"./images/icons/icon-emissions.svg": 53802,
	"./images/icons/icon-environmental.svg": 80462,
	"./images/icons/icon-external-link.svg": 96940,
	"./images/icons/icon-family.svg": 64610,
	"./images/icons/icon-food-security.svg": 1905,
	"./images/icons/icon-gas-station.svg": 42586,
	"./images/icons/icon-gem-blue.svg": 15584,
	"./images/icons/icon-glasses.svg": 2890,
	"./images/icons/icon-governance.svg": 77318,
	"./images/icons/icon-group-blue.svg": 12612,
	"./images/icons/icon-health-blue.svg": 82137,
	"./images/icons/icon-link.svg": 45510,
	"./images/icons/icon-location.svg": 26987,
	"./images/icons/icon-megaphone-blue.svg": 55089,
	"./images/icons/icon-music-blue.svg": 42408,
	"./images/icons/icon-photo.svg": 37238,
	"./images/icons/icon-pollution.svg": 56772,
	"./images/icons/icon-receipt-blue.svg": 97495,
	"./images/icons/icon-refresh.svg": 49315,
	"./images/icons/icon-savings-blue.svg": 29224,
	"./images/icons/icon-search-document.svg": 20964,
	"./images/icons/icon-search.svg": 77494,
	"./images/icons/icon-shield.svg": 75645,
	"./images/icons/icon-social-blue.svg": 82000,
	"./images/icons/icon-social.svg": 10771,
	"./images/icons/icon-strength.svg": 71473,
	"./images/icons/icon-sustainability.svg": 61229,
	"./images/icons/icon-thunder-green.svg": 79682,
	"./images/icons/icon-thunder.svg": 92728,
	"./images/icons/icon-trash.svg": 35352,
	"./images/icons/icon-tree.svg": 27786,
	"./images/icons/icon-upload-file.svg": 92984,
	"./images/icons/icon-verified.svg": 76310,
	"./images/icons/icon-wallet-blue.svg": 73086,
	"./images/icons/icon-warning.svg": 22170,
	"./images/icons/icon-water.svg": 1239,
	"./images/icons/icon-yin-blue.svg": 73823,
	"./images/icons/light-white.svg": 67450,
	"./images/icons/light.svg": 16366,
	"./images/icons/location.svg": 37151,
	"./images/icons/medal.svg": 82135,
	"./images/icons/pie-chart.svg": 20559,
	"./images/icons/pointer.svg": 55141,
	"./images/icons/search.svg": 30490,
	"./images/icons/thumb-up.svg": 11900,
	"./images/icons/time.svg": 55029,
	"./images/icons/upload-file.svg": 36268,
	"./images/icons/user.svg": 21755,
	"./images/idea.svg": 83546,
	"./images/leaks.svg": 77441,
	"./images/light-bulb.svg": 34723,
	"./images/litzyProfile.jpg": 96072,
	"./images/logo-OVE.svg": 15801,
	"./images/logo.svg": 3914,
	"./images/other_emissions.svg": 45738,
	"./images/panel-open.svg": 45676,
	"./images/products/MasterClasses.svg": 58532,
	"./images/products/assessment.svg": 21888,
	"./images/products/carbon.svg": 78937,
	"./images/profile.svg": 42198,
	"./images/proposal/cover.jpg": 38093,
	"./images/proposal/gstc-member.png": 89252,
	"./images/proposal/seal-light.png": 31414,
	"./images/proposal/seal.png": 27957,
	"./images/providers/logo-quickbooks.png": 57023,
	"./images/providers/logo-sap.png": 56444,
	"./images/providers/sage-logo.png": 88688,
	"./images/publication.svg": 55467,
	"./images/rain.svg": 10061,
	"./images/rate-icon.svg": 41469,
	"./images/recycle.svg": 43694,
	"./images/reductions.svg": 78277,
	"./images/report.svg": 68853,
	"./images/sharedReport/bg-env.jpg": 24420,
	"./images/sharedReport/header-enviromental.jpg": 58895,
	"./images/sharedReport/header-governance.jpg": 18083,
	"./images/sharedReport/header-social.jpg": 43666,
	"./images/sharedReport/header-water.jpg": 72134,
	"./images/social-banner-icon.svg": 22373,
	"./images/social-icon.svg": 9692,
	"./images/spreadsheeticon.svg": 32024,
	"./images/stripe-logo.svg": 42520,
	"./images/suppliers/hero.jpg": 41717,
	"./images/thumb-up.svg": 49185,
	"./images/to-submit.svg": 12485,
	"./images/training/_trainingbg.jpeg": 5945,
	"./images/training/trainingbg.jpg": 70969,
	"./images/transport.svg": 78586,
	"./images/transportation.svg": 7741,
	"./images/trash.svg": 18339,
	"./images/travel.svg": 57495,
	"./images/water.svg": 1380,
	"./images/waterconsumption.svg": 15753,
	"./images/wheel.svg": 14680,
	"./logo.png": 33153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96812;